import React, { Component } from 'react';
import Map from './Map';
import TW from './TW';
import TwitterPacific from './TwitterPacific';
import TwitterAtlantic from './TwitterAtlantic';
import { Grid, Row, Col } from 'react-flexbox-grid';

class Noaa extends Component {
    constructor() {
        
        super();
        this.state = {
            data: [],
            uniques: null,
            coords: {
              lat: 24.625212,
              long: -71.641996
            },
            isLoading: true,
            sourceAtlantic: {
                dataSource: {
                  sourceType: 'profile',
                  screenName: 'nhc_atlantic'
                },
                options: {
                  username: 'NHC_Atlantic',
                  height: '250'
                }},
            sourcePacific: {
                dataSource: {
                    sourceType: 'profile',
                    screenName: 'nhc_pacific'
                  },
                options: {
                    username: 'NHC_Pacific',
                    height: '250'
                }},
            infoWindow: {
                
            }
        };
    }
    
    getCoordinates = (x) => {
        if (x !== undefined) {
          let lastChar = x.charAt(x.length-1);
          let newCoords = parseFloat(x.slice(0, -1));
          if (lastChar === 'W' || lastChar === 'S') {
            return (-newCoords);
          }
        
          else {
            return newCoords;
          }
        }
    }

    changeCenter = (storm) => {
        let lat = this.getCoordinates(this.state.uniques[storm.getAttribute('id')].stormlat);
        let lng = this.getCoordinates(this.state.uniques[storm.getAttribute('id')].stormlong);
        this.setState({
            coords: {
            lat: lat,
            long: lng
            }
        });
    }

    findUniques = (data) => {
        if (data !== undefined) {
            let picks = [];
            let copy = data;
            for (let x in copy) {
                for (let y in data) {
                   if (copy[x].stormname === data[y].stormname) {
                       let dateX = Number(copy[x].datetime.slice(0, 2));
                       let dateY = Number(data[y].datetime.slice(0, 2));
                       let timeX = Number(copy[x].datetime.slice(3, 7));
                       let timeY = Number(data[y].datetime.slice(3, 7));
                       if (dateX === dateY) {
                           if (timeX > timeY) {
                                //console.log(timeX + ' is greater than ' + timeY);
                                let property = copy[x].stormname;
                                if (picks[property]) {
                                    let checkerDate = Number(picks[property].datetime.slice(0, 2));
                                    let checkerTime = Number(picks[property].datetime.slice(3, 7));
                                    if (checkerDate <= dateX) {
                                        if (checkerTime < timeX) {
                                            picks[property] = copy[x];
                                        }
                                    }
                                }
                                else {
                                    picks[property] = copy[x];
                                }
                                
                           }
                       }
                       else if (dateX === 31 && dateY === 1) {
                            let property = data[y].stormname
                            picks[property] = data[y];
                       }
                       else if (dateX === 30 && dateY === 1) {
                            let property = data[y].stormname
                            picks[property] = data[y];
                       }
                       else if (dateX > dateY) {
                            //console.log(dateX + ' is greater than ' + dateY);
                            let property = copy[x].stormname;
                            if (picks[property]) {
                                let checkerDate = Number(picks[property].datetime.slice(0, 2));
                                let checkerTime = Number(picks[property].datetime.slice(3, 7));
                                if (checkerDate <= dateX) {
                                    if (checkerTime < timeX) {
                                        picks[property] = copy[x];
                                    }
                                }
                            }
                            else {
                                picks[property] = copy[x];
                            }
                       } 
                   }
                }
            }
            return picks;
        }
    }

    capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

    addTracker = (uniques) => {
        if (uniques) {
            let linkArray = []
            for (let u in uniques) {
                let name = this.capitalizeFirstLetter(uniques[u].stormname.toLowerCase())
                let link = <li key={uniques[u].timestamp} id={uniques[u].stormname} onClick={(e) => this.changeCenter(e.target)}>{name}</li>
                linkArray.push(link)
            }
            return linkArray;
        }

        else {
            return <p>Loading...</p>
        }
    }

    handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }

    componentDidMount() {
        fetch('https://api.darkskyweather.com')
        .then((response) => this.handleErrors(response))
        .then((responseJson) => {
            this.setState({data : responseJson,
            uniques: this.findUniques(responseJson),
            isLoading: false
            })
        })
        .catch((error) => {
            console.error(error);
        })
    }

    render() {
        const {uniques} = this.state;
        if (this.state.isLoading) {
            return (
                <div>
                    <p>Loading...</p>
                </div>
            )
        }
        else {
            return (
                <div>
                    {uniques && <Map uniques={uniques} coords={this.state.coords}/>}
                    <div className="Everything-Else">
                    <Grid fluid>
                        <Row>
                        <Col xs={12} md={3}>
                        <div className="Tracker">
                            <h3 className="Small-Header">Select a storm to track</h3>
                            <ul>{this.addTracker(uniques)}</ul>
                        </div>
                        </Col>
                        <Col xs={12} md={3}>
                        <div className="TW-Posts">
                            <h3 className="Small-Header">Posts from <a href="https://reddit.com/r/tropicalweather" target="blank">/r/TropicalWeather</a></h3>
                            <TW />
                        </div>
                        </Col>
                        <Col xs={12} md={3}>
                        <div className="TwitterAtlantic"><TwitterAtlantic source={this.state.sourceAtlantic}/></div>
                        </Col>
                        <Col xs={12} md={3}>
                        <div className="TwitterPacific"><TwitterPacific source={this.state.sourcePacific}/></div>   
                        </Col>
                        </Row>
                    </Grid>
                        
                        
                        
                             
                    </div>
                    
                </div>
            ) 
        }
    }
}
export default Noaa;


// WEBPACK FOOTER //
// ./src/components/Noaa.js